import { CircleEmptyAlertIcon, Typography } from "@codat/orchard-ui";
import classNames from "classnames";
import React from "react";

import styles from "./Banner.module.css";

export interface BannerProps {
  title: string;
  icon?: React.ReactElement;
  variant: "info" | "warning" | "error" | "action";
  subtitle?: string;
  cta?: React.ReactElement;
  ["data-testid"]?: string;
}

const Banner: React.FC<BannerProps> = ({
  title,
  icon,
  variant,
  subtitle,
  cta,
  ["data-testid"]: dataTestId,
}) => {
  return (
    <div
      className={classNames(styles.banner, {
        [styles.negative]: variant === "error",
        [styles.warning]: variant === "warning",
        [styles.action]: variant === "action",
      })}
      data-testid={dataTestId || "banner"}
    >
      <div className={styles.icon}>
        {icon ?? <CircleEmptyAlertIcon data-testid="circle-alert-icon" />}
      </div>
      <div>
        <Typography
          as="div"
          variant="heading_sm"
          className={styles.text}
          data-testid="banner-title"
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            as="div"
            variant="body_sm"
            className={styles.text}
            data-testid="banner-subtitle"
          >
            {subtitle}
          </Typography>
        )}
      </div>
      {cta && <div className={styles.cta}>{cta}</div>}
    </div>
  );
};

export default Banner;
